module.exports = __webpack_public_path__ + "static/img/role-pt.cd1fe02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-3/role-pt.png
// module id = a1HA
// module chunks = 1